
import { Union } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { bool_type, int32_type, union_type } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";

export class TaskResultMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Finished", "Success", "Fail"];
    }
}

export function TaskResultMsg_$reflection() {
    return union_type("MatheApp.Domain.TaskResultMsg", [], TaskResultMsg, () => [[], [], []]);
}

export function TaskResultMsgModule_updateState(state) {
    return [state, undefined];
}

export function TaskResultMsgModule_success(state) {
    return [state, new TaskResultMsg(1, [])];
}

export function TaskResultMsgModule_finish(state) {
    return [state, new TaskResultMsg(0, [])];
}

export function TaskResultMsgModule_fail(state) {
    return [state, new TaskResultMsg(2, [])];
}

export class InputMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ZifferEingeben", "KommaEingeben", "Löschen"];
    }
}

export function InputMsg_$reflection() {
    return union_type("MatheApp.Domain.InputMsg", [], InputMsg, () => [[["ziffer", int32_type]], [], [["alles", bool_type]]]);
}

